// test1942
(1942 && 0);
